import "babel-polyfill";
import React, { Component } from "react";
import { HashRouter as Router } from "react-router-dom";
// import { Redirect } from "react-router-dom";
import { Route, Redirect, Switch } from "react-router-dom";

import asyncComponent from "./services/async.component";

import Translations from "./services/translation.service";

// import Summaries from "./services/summaries.service";
import Activation from "./services/activation.service";


// import Routes from "./services/routes.service";
import Helpers from "./helpers/shared.helper";
import Storage from "./services/storage.service";
import User from "./services/user.service";
// import Header from "./views/shared/header.component";
import Flow from "./services/flow.service";
import Plans from "./services/plans.service";

import Message from "./views/shared/message.component";

import "./App.css";

import Spinner from "./views/shared/spinner.component";
import GTMService from "./services/gtm.service";
import Products from "./services/products.service";
import HTTP from "./services/http.service";
import Settings from "./services/settings.service";
import mnpNumberContext from "./context/MNP_Number";

import createHistory from "history/createBrowserHistory";
// import StreamOffers from "./ui/stream_offers";
// import StreamMultipleOffers from "./ui/stream_multiple_offers";
// import ESimDoubleData from "./ui/esim_double_data";
// import EsimDetailsPopup from "./ui/esim_details_popup";
// import PromoOfferPopup from "./views/shared/promotion-popup.component";
import FirebaseAnalytics from "./services/firebaseAnalytics";
import StorefrontHeader from "./views/shared/storefront-header.component";
// import CategoryTabs from "./views/storefront/categoryTabs/category-tabs.component";
import Footer from "./views/shared/footer.component";
// import TopSlider from "./views/shared/top-slider.component";
import ScreenLoader from "./views/shared/screen-loader.component";
import planFG from "./services/planFg.service";
import ContentServiceModal from "./views/storefront/content-service-modal/contentServiceModal";
import ProgressBar from "./views/shared/progressBar";
import DropOffWrapper from "./views/shared/dropOffWrapper";
import DropOffModal from "./views/shared/dropOffModal";
import SpinnerTimeLoader from "./views/shared/timeLoading";
import Advertisement from "./ui/advertisement";
import STF_CONSTANTS from "./services/stfConstant.service";
import storefront from "./services/storefront.service";
import AlmostDone from "./views/shared/AlmostDone";
// import StoreLocator from "./views/sim/store-locator.component";
// import StoreLocatorContainer from "./views/sim/instore-activation-container.component";
// import StorefrontNumberSearch from "./views/numbers/storefront-number-search.component";
// import RandomNumber from "./views/numbers/random-number";
// import NoNumbers from "./views/shared/no-numbers.component";
// import NumberStatus from "./views/shared/number-status";
// import BringYourNumberCard from "./views/storefront/bring-your-own-number/bringYourOwnNumber";
// import STF_CONSTANTS from "./services/stfConstant.service";
// import PlanSelection from "./views/storefront/planSelection/planSelection";
// import Summary from "./views/shared/summary.component";
// import StmSummary from "./views/shared/storefront-summary";
// import BuildYourOwnPlan from "./views/storefront/build-you-own-plan";
// import ActiavtionReady from "./views/sim/stm-activation-ready";
// import NumberSearchUi from "./ui/storefront/number_search";
// import CheckElegibilityForm from "./views/storefront/check-eligibility-form/checkEligibilityFrom";
// import ActivationSuccess from "./views/sim/stm-activation-success";
// import OtpScreen from "./views/storefront/otp-screen/otpScreen";
// import FailedEligibilityScreen from "./views/storefront/failed-eligibility-screen/failedEligibilityScreen";
// import SimSelection from "./views/storefront/sim-selection/simSelection";
// import Footer from "./views/shared/footer.component";
// import PromoAdvertisement from "./ui/promo_advertisement";

const history = createHistory({
  basename: "", // The base URL of the app (see below)
  hashType: "hash" // The hash type to use (see below)
});

const AsyncReceiveToken = asyncComponent(() => {
  return import("./views/payment/receive-token.component");
});

const AsyncConfirmation = asyncComponent(() => {
  return import("./views/payment/confirmation.component");
});

const AsyncApplePayConfirmationOb = asyncComponent(() => {
  return import("./views/payment/confirmation-apple-pay.component");
});

const AsyncApplePayFailedOb = asyncComponent(() => {
  return import("./views/payment/confirmation-apple-pay-failed.component");
});

const AsyncAbsherValidation = asyncComponent(() => {
  return import("./views/sim/absher-validation.component");
});

const AsyncDelivery = asyncComponent(() => {
  return import("./ui/sim_delivery");
});

const AsyncSimDeactivation = asyncComponent(() => {
  return import("./ui/sim_deactivation");
});

const AsyncProtectionChannel = asyncComponent(() => {
  return import("./ui/protection_channel");
});

const AsyncTempComponent = asyncComponent(() => {
  return import("./ui/in_store_activation");
});
const AsyncApplyPayConfirmation = asyncComponent(() => {
  return import("./views/topUp/top-up-success");
});

const AsyncApplyPayFailure = asyncComponent(() => {
  return import("./views/topUp/top-up-failed");
});

class App extends Component {

  history_listener = null;

  updateMnpNumber = (number) => {
    this.setState({
      mnpNumber: number
    })
  }

  state = {
    route: null,
    routes: null,
    flow_loaded: false,
    translations_loaded: 0,
    error: null,
    classes: "",
    direction: null,
    mnpNumber: '',
    theme: 'light',
    wp_loader: false
  };

  import_list = {};
  subscriptions = [];
  prefix = "";

  params = {};

  fetchingTheme = () => {
    Storage.set("themeLoading", true);
    let config = {
      method: "get",
      url: "/graphs/theme"
    };
    HTTP(config)
      .then(response => {
        const placeholder_images = response.data.placeholder_images;
        const anghami_promotion_images = response.data.anghami_promotion_images;
        const predefinedplan_images = response.data.predefinedplan_images;
        const stf_predefined_img = response.data.stf_predefined_img;
        const stf_category_topup_img = response.data.stf_category_topup_img;

        
        const stf_predefined_plan_fg_images = response.data.stf_predefined_plan_fg_images;
        const predefined_plan_fg_images = response.data.predefined_plan_fg_images
        const stf_streaming_img = response.data.stf_streaming_img;
        const stf_cards_banner_bg = response.data.stf_cards_banner_bg;
        const stf_banner_streaming = response.data.stf_banner_streaming;
        const stf_cards_banner_img = response.data.stf_cards_banner_img;
        const offers_advertising = response.data.offers_advertising;
        const offers_images = response.data.offers_images;
        const content_services = response.data.content_services;
        const content_services_description = response.data.content_services_description;
        const stf_vanity_img = response.data.stf_vanity_img;
        const plan_colors = response.data.plan_colors;
        const stf_category_icons = response.data.stf_category_icons;
        const stf_offer_banner_images = response.data.stf_offer_banner_images;
        const stf_cards_banner_bg_color = response.data.stf_cards_banner_bg_color;
        const stf_cards_banner_text_color = response.data.stf_cards_banner_text_color;
        const stf_eligibility_tab = response.data.stf_eligibility_tab;
        const stf_category_topup_color = response.data.stf_category_topup_color;

        Storage.set("placeholder_images", JSON.stringify(placeholder_images), true);
        Storage.set("stf_offer_banner_images", JSON.stringify(stf_offer_banner_images), true);
        Storage.set("anghami_promotion_images", JSON.stringify(anghami_promotion_images), true);
        Storage.set("predefinedplan_images", JSON.stringify(predefinedplan_images), true);
        Storage.set("predefined_plan_fg_images", JSON.stringify(predefined_plan_fg_images), true);
        Storage.set("stf_predefined_img", JSON.stringify(stf_predefined_img), true);
        Storage.set("stf_category_topup_img", JSON.stringify(stf_category_topup_img), true);        
        Storage.set("stf_predefined_plan_fg_images", JSON.stringify(stf_predefined_plan_fg_images), true);
        Storage.set("stf_streaming_img", JSON.stringify(stf_streaming_img), true);
        Storage.set("offers_advertising", JSON.stringify(offers_advertising), true);
        Storage.set("offers_images", JSON.stringify(offers_images), true);
        Storage.set("content_services", JSON.stringify(content_services), true);
        Storage.set("stf_cards_banner_bg", JSON.stringify(stf_cards_banner_bg), true);
        Storage.set("stf_banner_streaming", JSON.stringify(stf_banner_streaming), true);
        Storage.set("stf_cards_banner_img", JSON.stringify(stf_cards_banner_img), true);
        Storage.set("content_services_description", JSON.stringify(content_services_description), true);
        Storage.set("stf_vanity_img", JSON.stringify(stf_vanity_img), true);
        Storage.set("plan_colors", JSON.stringify(plan_colors), true);
        Storage.set("stf_category_icons", JSON.stringify(stf_category_icons), true);
        Storage.set("stf_cards_banner_bg_color", JSON.stringify(stf_cards_banner_bg_color), true);
        Storage.set("stf_cards_banner_text_color", JSON.stringify(stf_cards_banner_text_color), true);
        Storage.set("stf_eligibility_tab", JSON.stringify(stf_eligibility_tab), true);
        Storage.set("stf_category_topup_color", JSON.stringify(stf_category_topup_color), true);

        let theme = response.data.Vanities;
        theme["created_at"] = Date.parse(new Date());
        theme["version"] = Settings["theme_version"];

        Storage.set("theme", JSON.stringify(theme), true);
        response.data.freeplan_promotion_images["created_at"] =
          theme["created_at"];
        response.data.freeplan_promotion_images["version"] = theme["version"];
        Storage.set(
          "freeplan_promotion_images",
          JSON.stringify(response.data.freeplan_promotion_images),
          true
        );
        Storage.set("themeLoading", false);
      })
      .catch(error => {
        Storage.set("themeLoading", false);
      });
  };

  getTheme = () => {
    let theme = JSON.parse(Storage.get("theme", true));
    if (theme) {
      //Set the two dates
      let y2k = Date.parse(new Date(theme["created_at"]));
      let today = Date.parse(new Date());
      // let today= Date.parse("Feb 25, 2019");

      if (
        Helpers.dateDiff("n", y2k, today) + 1 >
        Settings["data_expiry_duration"] ||
        Settings["theme_version"] !== theme["version"]
      ) {
        this.fetchingTheme();
      }
    } else {
      this.fetchingTheme();
    }
  };

  loadCSSByDirection = dir => {
    this.setState({
      direction: dir
    });
  };

  loadCSSByTheme = type => {
    this.setState({
      theme: type
    });
  };

  // <div className="changer" onClick={() => {
  //   if(this.state.theme === "light"){stf_predefined_img
  //     this.loadCSSByTheme("dark");
  //   } else {
  //     this.loadCSSByTheme("light");  
  //   }
  // }}>Change Theme</div>

  componentWillUnmount() {
    this.setState({ userSelectionSet: false })
    Storage.clear('offer_applied_local');
    // document.body.removeChild(scriptTapCdn);
    // document.body.removeChild(scriptTapSdk);
  }
  resetMnp = (flags) => {
    flags.chose_mnp = false;
    Storage.clear("chose_mnp");
    Storage.set("flags", flags);
  }

  mnpExpiry = () => {

  }


  //////////////////////// componentDidMount
  componentDidMount() {
    if (Helpers.isWWW()) {
      Helpers.forceNonWWW();
    }
    const scriptTapCdn = document.createElement("script");
    scriptTapCdn.src = Settings.tap_cdn_source;
    scriptTapCdn.async = true;
    scriptTapCdn.type = "text/javascript";
    const scriptTapSdk = document.createElement("script");
    scriptTapSdk.src = Settings.tap_sdk_source;
    scriptTapSdk.type = "text/javascript";
    scriptTapSdk.async = true;
    document.body.appendChild(scriptTapCdn);
    document.body.appendChild(scriptTapSdk);
    //  Helpers.log("App.js componentDidMount()");

    User.init();
    GTMService.init();
    Activation.init();

    this.getTheme();
    Translations.getTranslations(Translations.activeLang);
    Flow.getPOSettings();

    Translations.getTranslationsObsrv().subscribe(data => {
      if (Translations.activeLang === "ar") {
        this.loadCSSByDirection("RTL");
      } else {
        this.loadCSSByDirection("LTR");
      }

      if (data) {
        this.setState({
          translations_loaded: this.state.translations_loaded + 1
        });
      }
    });

    this.subscriptions.push(
      Flow.get_obsrv("flow_loaded").subscribe(data => {
        this.setState({ flow_loaded: data });
        if (data) {
          Storage.get_obsrv("session").subscribe(data => {
            if (data) {
              User.goToStatusRoute();
              Products.fetchAllowedFeatures();
            } else {
              User.checkUser();
            }
          });

          Storage.get_obsrv("error").subscribe(data => {
            this.setState({
              error: data
            });
          });
          // console.log(data)
          // Storage.get_obsrv("route").subscribe(data => {
          //   if (data) {
          //     this.setState({
          //       route: data
          //     });
          //   }
          // });

          Storage.get_obsrv("flags").subscribe(data => {
            if (data && this.state.flow_loaded) {
              // this.populateImports();
              // if(data["PlanSelected"] && Storage.get("StreamModal").SHOW===true)
              // Storage.set("StreamingModal",{'SHOW':false})
              if (!Helpers.exceptionParamsExist() && !this.state.userSelectionSet) {
                // alert('1.0')
                let storage_params = Helpers.getUserSelection();
                let fullImageBanner = window.localStorage.getItem("full_image_banner");
                if(fullImageBanner) {
                  if (
                    fullImageBanner === STF_CONSTANTS.CTA_BRING_YOUR_NUMBER ||
                    fullImageBanner === STF_CONSTANTS.CTA_GENERATE_NOW ||
                    fullImageBanner === STF_CONSTANTS.CTA_VIEW_ALL
                  ) {
                    storefront.selectCategory(fullImageBanner);
                  } else {
                    if (fullImageBanner === STF_CONSTANTS.CTA_CUSTOMIZE_PLAN) {
                      storefront.selectCustomPlan();
                    } else if (
                      fullImageBanner === STF_CONSTANTS.CTA_PLAN_SELECTION_TAP ||
                      fullImageBanner === STF_CONSTANTS.CTA_PLAN_CARD_TAP ||
                      fullImageBanner === STF_CONSTANTS.CTA_PLAN_LIST_TAP
                    ) {
                      storefront.selectPlan();
                    }
                  }
                  localStorage.removeItem("full_image_banner");
                }

                if (storage_params) {
                  if ((storage_params["plan_ids"] && !storage_params["bundle_id"]) ||
                    storage_params["bundle_id"] ||
                    storage_params["plan_type"]) {
                    this.setState({ userSelectionCheck: true });
                    let fg_product_code = storage_params["fg_product_code"];
                    let product_code = storage_params["product_code"];

                    if (storage_params["plan_type"] === "PRD-FG" ||
                      storage_params["plan_type"] === "CUS" ||
                      storage_params["plan_type"] === "PRD") {
                      User.updateFlowStatus("plan_type_selected", true).then(() => {
                        if (storage_params["plan_type"] === "PRD-FG") {
                          Storage.set("showPlanLoaderFull", true, true);
                          Storage.set("is_category_type_5g", true, true);
                          User.updateFlowStatus("is_broadband_plan_selected", true).then(res => {
                            planFG.getPredeinedFGplan(fg_product_code).then(response => {
                              Storage.set("is_broadband_plan_selected", true, true);
                              planFG.savehomePlan(storage_params, response?.data?.PreDefinedBundles).then(response => {
                                if (!this.state.populatedInports)
                                  this.populateImports();
                                this.setState({ userSelectionCheck: false });
                              }).catch(err => {
                                User.fetchFlowStatus();
                                if (!this.state.populatedInports)
                                  this.populateImports();
                                this.setState({ userSelectionCheck: false });
                                Storage.set("flags", data);
                              });
                            }).catch(err => {
                              if (!this.state.populatedInports)
                                this.populateImports();
                              this.setState({ userSelectionCheck: false });
                              Storage.set("flags", data);
                            })

                          }).catch(err => {
                            if (!this.state.populatedInports)
                              this.populateImports();
                            this.setState({ userSelectionCheck: false });
                            Storage.set("flags", data);
                          })
                        } else if (storage_params["plan_type"] === "PRD") {
                          this.setState({ wp_loader: true });
                          planFG.getPredeinedFGplan(product_code).then(response => {
                            Plans.processUserSelectionFromStorageParams(storage_params, response?.data?.PreDefinedBundles).then(response => {

                              if (!this.state.populatedInports)
                                this.populateImports();
                              this.setState({ userSelectionCheck: true, wp_loader: false });

                            }).catch(err => {
                              User.fetchFlowStatus();
                              if (!this.state.populatedInports)
                                this.populateImports();
                              this.setState({ userSelectionCheck: true, wp_loader: false });
                              Storage.set("flags", data);
                            });
                          }).catch(err => {
                            if (!this.state.populatedInports)
                              this.populateImports();
                            this.setState({ userSelectionCheck: true, wp_loader: false });
                            Storage.set("flags", data);
                          })
                        } else if (storage_params["plan_type"] === "CUS") {
                          Storage.set("is_web_category_selected", true, true);
                          Storage.set("choose_plan_category", true, true);
                          Storage.set("is_custom_card_selected", true, true);
                          Storage.set("plan_type", storage_params["plan_type"], true);
                          User.fetchFlowStatus();
                          this.setState({ userSelectionCheck: false, wp_loader: false });

                        }
                      }
                      ).catch(() => {
                        if (!this.state.populatedInports)
                          this.populateImports();
                        this.setState({ userSelectionCheck: false });
                        Storage.set("flags", data);
                      });

                    }
                  } else {
                    if (!this.state.populatedInports)
                      this.populateImports();

                  }

                  if (storage_params["MSISDN"]) {
                    // Numbers.postProcessReservedNumber();
                    // Summaries.init('storage_params["MSISDN"]');
                    Flow.goTo(Flow.get("root_id"));
                    this.resetMnp(data);
                  }

                  if (storage_params["chose_mnp"]) {
                    data.chose_mnp = true;
                    Storage.set("chose_mnp", true, true);
                    Storage.set("flags", data);

                  }
                  if (storage_params["start_search"]) {
                    Storage.set("is_web_category_selected", true, true);
                    Storage.set("web_search_more_number", true, true);
                    Storage.clear("start_search");
                    this.resetMnp(data);
                  }

                  let vanity_data = storage_params["vanity_level"]
                  if (vanity_data ||
                    Number(vanity_data) === 0) {
                    let vanityId = vanity_data === "0" ? vanity_data.toString() : Number(vanity_data);
                    Storage.set("active_search_vanity", vanityId);
                    Storage.set("is_web_category_selected", true, true);
                    Storage.set("web_search_more_number", true, true);
                    // Storage.clear("user_selection")
                  }


                  Storage.set("flags", data);
                  this.setState({ userSelectionSet: true });
                } else {
                  if (!this.state.populatedInports && !this.state.userSelectionCheck) this.populateImports();
                  let MNPSubmitedForm = JSON.parse(Storage.get('MNPSubmitedForm', true));
                  let mnpChecked = Storage.get("mnpChecked", true);
                  if (MNPSubmitedForm && !data.NumberSelected && !mnpChecked) {
                    data.mnp_pending = true;
                    data.chose_mnp = true;
                    Storage.set("mnpChecked", true, true);
                    Storage.set("flags", data);
                    Flow.goTo(Flow.get("root_id"));
                  }
                  if (Storage.get("choose_topup_category") !== true && window.location.href.includes("top_up")) {
                    Storage.set("choose_topup_category", true, true);
                    Storage.set("is_web_category_selected", true, true);
                    User.fetchFlowStatus();
                  }
                  else {
                    // Summaries.init("no exceptions");
                    Flow.goTo(Flow.get("root_id"));
                  }

                }
              } else {
                if (!this.state.populatedInports && !this.state.userSelectionCheck) this.populateImports();
                if (Helpers.receiverPagesExist()) {
                  if (window.location.href.indexOf("payfort_token") !== -1) {
                    if (window) {
                      this.params = Helpers.getParams();
                      if (
                        this.params.string
                        && Storage.get("payfort_params") !== this.params.string
                      ) {
                        Storage.set("payfort_params", this.params.string);
                        if (this.params.pieces.response_code === "18000") {
                          Helpers.log("Received token");
                          window.parent.setToken(this.params.pieces.token_name);
                        } else {
                          window.parent.setToken(null);
                        }
                      }
                    }
                  }
                  else if (window.location.href.indexOf("confirmation") !== -1) {
                    // Do Nothing
                    if (!Storage.get("visitedConfirmation")) {
                      Storage.set("visitedConfirmation", true);
                      Flow.goTo();
                    }

                  } else {
                    Flow.goTo();
                  }
                } else {
                  Helpers.log("found exception path");
                  // Summaries.init("exceptions");
                  Flow.goTo();
                }

              }
            }
          });

        }
      })
    );

    this.subscriptions.push(
      Flow.get_obsrv("current").subscribe(data => {
        let route = null;
        if (data) {
          if (data["web_pathname"]) {
            // GTMService.set_page_title('Page_name',data["web_pathname"]);
            Storage.set("Page_name", data["web_pathname"]);
          }

          let path = data["web_pathname"] ? data["web_pathname"] : data["name"];
          if (!path) {
            path = data;
          }

          route = (
            <Redirect key={path + Date.now().toString()} to={"/" + path} />
          );

          if (Settings.enable_history) {
            if (data && history.location.hash !== "#" + path) {
              history.push("#" + path);
            }
          }
          //  console.log(data);
          this.setState({
            route: route,
            classes: data["name"]
          });
        }
      })
    );
  }
  //////////////////////// componentDidMount

  populateImports = () => {
    let uis_to_import = Flow.get("uis_to_import");
    let routes = [];

    for (let ui_component of uis_to_import) {
      if (!this.import_list[ui_component]) {
        this.import_list[ui_component.path] = asyncComponent(() =>
          import("./ui/" + ui_component.name)
        );
      }
    }
    // console.log("inports")
    for (let route of Object.keys(this.import_list)) {
      routes.push(
        <Route
          path={"/" + route.substr(this.prefix.length)}
          exact
          key={route}
          component={this.import_list[route]}
        />
      );
    }
    this.setState({
      routes: routes,
      populatedInports: true
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.state.translations_loaded !== nextState.translations_loaded ||
      this.state.route !== nextState.route ||
      this.state.classes !== nextState.classes ||
      this.state.direction !== nextState.direction ||
      this.state.error !== nextState.error ||
      this.state.mnpNumber !== nextState.mnpNumber ||
      this.state.showStreaming !== nextState.showStreaming ||
      this.state.showModalSpinner !== nextState.showModalSpinner ||
      this.state.userSelectionCheck !== nextState.userSelectionCheck ||
      this.state.theme !== nextState.theme ||
      this.state.wp_loader !== nextState.wp_loader
    )
      return true;
    return false;
  }

  render() {
    let redirection = null;
    if (this.state.route) {
      redirection = this.state.route;
    }

    let content = <SpinnerTimeLoader />;
    let error = "";
    let router_switch = "";

    if (this.state.translations_loaded) {
      if (Settings?.firebase_analytics_configs) {
        FirebaseAnalytics.init();
      }
      if (Settings.disable_routing) {
        content = (
          <Switch>
            <Route path="*" exact component={AsyncTempComponent} />
          </Switch>
        );
      }


      if (this.state.routes) {
        content = this.state.routes;
      } else {
        // if (Settings.disable_routing) {
        //   content = (
        //     <Switch>
        //       <Route path="*" exact component={AsyncTempComponent} />
        //     </Switch>
        //   );
        // }
      }

      router_switch = (
        <Switch>
          {content}
          <Route
            path="/payfort_token"
            key={"/payfort_token" + Date.now()}
            exact
            component={AsyncReceiveToken}
          />
          <Route
          path="/scan-qr-code"
          key={"/scan-qr-code" + Date.now()}
          exact
          component={(props) => <AlmostDone />}
        />
        <Route
          path="/confirmation-apple"
          key={"/confirmation-apple" + Date.now()}
          exact
          component={AsyncApplyPayConfirmation}
        />

        <Route
          path="/apple-pay-failure"
          key={"/apple-pay-failure" + Date.now()}
          exact
          component={AsyncApplyPayFailure}
        />
          <Route
            path="/confirmation"
            key={"/confirmation" + Date.now()}
            exact
            component={AsyncConfirmation}
          />
          <Route
            path="/confirmation-apple-onboarding"
            key={"/confirmation-apple-onboarding" + Date.now()}
            exact
            component={AsyncApplePayConfirmationOb}
          />
          <Route
            path="/apple-pay-failure-onboarding"
            key={"/apple-pay-failure-onboarding" + Date.now()}
            exact
            component={AsyncApplePayFailedOb}
          />
          <Route
            path="/absher-validation"
            key={"/absher-validation" + Date.now()}
            exact
            component={AsyncAbsherValidation}
          />
          {/* <Route
          path="/payment"
          key={"/payment" + Date.now()}
          exact
          component={AsyncPayment}
        /> */}
          <Route
            path="/delivery"
            key={"/delivery" + Date.now()}
            exact
            component={AsyncDelivery}
          />
          <Route
            path="/sim-deactivation"
            key={"/sim-deactivation" + Date.now()}
            exact
            component={AsyncSimDeactivation}
          />
          <Route
            path="/protection-channel"
            key={"/protection-channel" + Date.now()}
            exact
            component={AsyncProtectionChannel}
          />
          <Route
            path="/advertisement"
            key={"/advertisement" + Date.now()}
            exact
            // component={AsyncAdvertisement}
            component={(props) => <Advertisement history={props.history} flow="number" />}

          />
          <Route
            path="/advertisement/otp/"
            key={"/advertisement/otp/" + Date.now()}
            exact
            // component={AsyncAdvertisementOptions}
            component={(props) => <Advertisement history={props.history} flow={"otp"} />}
          />
        </Switch>
      );

      if (this.state.error) {
        if (
          this.state.error === "error_unsupported_delivery_location" ||
          this.state.error === "error_delivery_unavailable"
        ) {
          error = (
            <Message
              error={this.state.error}
              action={() => {
                Storage.set("delivery_status", null);
                Flow.goTo();
              }}
            />
          );
        } else if (this.state.error === "error_email_not_found") {
          error = <Message error={this.state.error} action={Flow.goTo} />;
        } else {
          error = <Message error={this.state.error} />;
        }

        router_switch = "";
      }
    }

    return (
      <div className={`theme-${this.state.theme} ${this.state.direction}`} dir={this.state.direction}>
        <mnpNumberContext.Provider value={{
          mnpNumber: this.state.mnpNumber,
          updateMnpNumber: this.updateMnpNumber
        }}>
          <Router>
            <div>
              <div
                className={
                  "wrapper oct10-16:56 " +
                  this.state.classes
                }
              >
                <ScreenLoader />
                <StorefrontHeader />
                <ProgressBar />
                {/* <div className="changer" onClick={() => {
                  if(this.state.theme === "light"){
                    this.loadCSSByTheme("dark");
                  } else {
                    this.loadCSSByTheme("light");  
                  }
                }}>Change Theme</div> */}
                <DropOffWrapper
                  error={error}
                >
                  {this.state.wp_loader ? <Spinner /> :
                    <>
                      {router_switch}
                      {redirection}
                    </>
                  }
                </DropOffWrapper>
                {error}
                {localStorage.getItem("WelcomeBack") &&
                  localStorage.getItem("is_category_type_5g") === "false" &&
                  window.location.href.indexOf("category") === -1 &&
                  window.location.href.indexOf("search-number") === -1 &&
                  window.location.href.indexOf("activation-inprogress") === -1 &&
                  window.location.href.indexOf("activation-failed") === -1 &&
                  window.location.href.indexOf("activated") === -1 &&
                  window.location.href.indexOf("store-pickup") === -1 &&
                  window.location.href.indexOf("delivery") === -1 &&
                  window.location.href.indexOf("absher-validation") === -1 &&
                  window.location.href.indexOf("confirmation") === -1 &&
                  window.location.href.substr(-3) !== "/#/" &&
                  window.location.href.indexOf("random") === -1 &&
                  window.location.href.indexOf("number") === -1 &&
                  window.location.href.indexOf("mnp") === -1 &&
                  window.location.href.indexOf("activation-success") === -1 && (
                    <DropOffModal history={history} />
                  )}
                <Footer />
              </div>
            </div>
          </Router >
          {/* <StreamOffers handleModalButton={() => this.handleModalButton()} />
          <StreamMultipleOffers />
          <ESimDoubleData />
          <EsimDetailsPopup />
          <PromoOfferPopup /> */}
          {/* <PromoAdvertisement /> */}
          <ContentServiceModal />
        </mnpNumberContext.Provider >
      </div>
    );
  }
}

export default App;
